import { Grid } from '@ui-kit/Grid';
import { useAppSelector } from '@redux/hooks';
import { MyLink } from '@ui-kit/Link';
import { ServiceEcommerce2 } from '@app/services/ServiceEcommerce';
import classNames from 'classnames';

import IconVk from 'public/next/img/Footer/social-network/vk.svg';
import IconDrive from 'public/next/img/Footer/social-network/drive.svg';
import IconZen from 'public/next/img/Footer/social-network/zen.svg';
import IconTelegram from 'public/next/img/Footer/social-network/telegramm.svg';
import IconTiktok from 'public/next/img/Footer/social-network/tiktok.svg';
import IconYoutube from 'public/next/img/Footer/social-network/youtube.svg';

import styles from './SocialNetwork.module.scss';

const getIcon = (title: string): JSX.Element => {
  switch (title) {
    case 'Vk':
      return <IconVk></IconVk>;
    case 'telegram':
      return <IconTelegram></IconTelegram>;
    case 'zen.yandex':
      return <IconZen></IconZen>;
    case 'Drive':
      return <IconDrive></IconDrive>;
    case 'YouTube':
      return <IconYoutube></IconYoutube>;
    case 'TikTok':
      return <IconTiktok></IconTiktok>;
    default:
      return <></>;
  }
};

export const SocialNetworkBlock = ({ className }: { className?: string }): JSX.Element => {
  const { socialLinks } = useAppSelector(state => state.header.data.headerMenu);
  return (
    <Grid gap={'14px'} className={classNames(styles.Wrapper, className)} row>
      {socialLinks?.map(icon => (
        <MyLink
          key={icon?.title}
          href={icon?.url || ''}
          target={'_blank'}
          data-testid={icon?.url}
          onClick={() => ServiceEcommerce2.phoneCallback()}
        >
          {getIcon(icon?.title)}
        </MyLink>
      ))}
    </Grid>
  );
};
